module.exports = __webpack_public_path__ + "static/energy-bc33a71105a6058eaa233384a3b98bb6.jpg";